export class PaneState {
  public noteIds: string[] = [];
}
